import React from "react";
import styles from "./Table.module.css";

export default function CompanyTab({ company }) {
  if (!company) {
    return (
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <tbody>
            <tr>
              <td colSpan="5">
                <p>Данные компании отсутствуют</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  // Тип компании
  const typeMap = {
    individual: "ИП",
    llp: "ТОО",
    jsc: "АО",
  };
  const typeLabel = typeMap[company.type] || "-";

  // Директор
  const director =
    company.owners && company.owners.length > 0
      ? `${company.owners[0].name || ""} ${company.owners[0].surname || ""}`
      : "-";

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Тип</th>
            <th>Директор</th>
            <th>Плательщик НДС</th>
            <th>Дата создания</th>
            <th>Полный адрес</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{typeLabel}</td>
            <td>{director}</td>
            <td>{company.pay_status ? "Да" : "Нет"}</td>
            <td>
              {company.inserted_at
                ? new Date(company.inserted_at).toLocaleDateString()
                : "-"}
            </td>
            <td>{company.address?.full || "-"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
